import * as types from './attachmentActionTypes';
import { createAction } from 'utils/reduxUtil';

export const isRefreshing = refreshing =>
  createAction(types.IS_REFRESHING, { refreshing });
export const listRequest = (referenceType, referenceId) =>
  createAction(types.LIST_REQUEST, { referenceType, referenceId });
export const listSuccess = (referenceId, attachments) =>
  createAction(types.LIST_SUCCESS, { referenceId, attachments });
